export default __webpack_public_path__ + "static/media/timer_m2.d0afe90a.png";